/**
 * @file AgendaFlag.ts
 * @brief Agenda's own icon: a flag planted on a list (was ClipboardCheck / ListChecks / CalendarDays where they meant agenda).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/AgendaFlag.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const AgendaFlag = createLucideIcon("AgendaFlag", [
  ["path", { d: "M4 21V3", key: "pole" }],
  ["path", { d: "M4 4h8.5l-2 3 2 3H4", key: "flag" }],
  ["path", { d: "M8 14h13", key: "point-1" }],
  ["path", { d: "M8 18.5h9", key: "point-2" }],
]);

export default AgendaFlag;
